import { queryOptions, useQuery } from '@tanstack/react-query';
import { getValidated } from '@shared/api';
import { exchangeRateKeys } from './keys';
import { ExchangeRateResponseSchema } from './schemas';
import { toExchangeRate } from './mappers';

/**
 * Single-date FX rate (`GET /api/v1/exchange-rate/rate?base=&quotes=&date=`). The endpoint uses the
 * plural query key `quotes`. Only runs when base/quote/date are set and the currencies differ (no
 * point converting a currency to itself). Cached an hour — a rate for a given date is stable.
 */
export function exchangeRateQueryOptions(base: string, quote: string, date: string) {
  return queryOptions({
    queryKey: exchangeRateKeys.rate(base, quote, date),
    queryFn: () =>
      getValidated('api/v1/exchange-rate/rate', ExchangeRateResponseSchema, {
        base,
        quotes: quote,
        date,
      }),
    select: (res) => (res.data ? toExchangeRate(res.data) : null),
    enabled: Boolean(base) && Boolean(quote) && Boolean(date) && base !== quote,
    staleTime: 60 * 60 * 1000,
  });
}

export function useExchangeRate(base: string, quote: string, date: string) {
  return useQuery(exchangeRateQueryOptions(base, quote, date));
}
